// useProfileForm.js

import {useState, useEffect, useCallback, useRef} from 'react';
import { validateField, validateForm } from './validation';
import {formFields} from "./fieldConfig";



export const useProfileForm = (initialData = null) => {
    const [formData, setFormData] = useState(initialData);
    const [dependents, setDependents] = useState([]);
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState({});
    const [isDirty, setIsDirty] = useState(false);
    const [loading, setLoading] = useState(false);
    const debounceTimeoutRef = useRef({});

    useEffect(() => {
        if (isDirty) {
            const validationErrors = validateForm(formData, dependents, formFields);
            setErrors(validationErrors);
        }
    }, [formData, dependents, isDirty]);

    const generateUniqueId= () => {
        return '_' + Math.random().toString(36).substr(2, 9);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setIsDirty(true);

        // Find the section and field config for this field
        let fieldConfig = null;
        let sectionKey = null;

        Object.entries(formFields).some(([secKey, section]) => {
            if (section.fields[name]) {
                fieldConfig = section.fields[name];
                sectionKey = secKey;
                return true;
            }
            return false;
        });

        // Only validate if the field is visible
        console.warn('VALIDATE');
        console.log(fieldConfig);
        if(typeof fieldConfig.showIf === 'function'){
            console.log(fieldConfig.showIf(formData));
        }
        console.log(fieldConfig.showIf)
        if (fieldConfig && fieldConfig.required &&  (!formFields[sectionKey].showIf || formFields[sectionKey].showIf(formData)) &&
            (!fieldConfig.showIf || fieldConfig.showIf(formData))) {
            const fieldErrors = validateField(name, value, formData);
            if (fieldErrors.length > 0) {
                setErrors(prev => ({
                    ...prev,
                    [name]: fieldErrors
                }));
            } else {
                setErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors[name];
                    return newErrors;
                });
            }
        }
    };

    const handleDependentChange = useCallback((id, field, value) => {
        setDependents((prevDependents) =>
                          prevDependents.map((dep) =>
                                                 dep.id === id ? { ...dep, [field]: value } : dep
                          )
        );
    }, []);



// Modify handleDependentAdd
    const handleDependentAdd = () => {
        setDependents(prev => [
            ...prev,
            {
                id: generateUniqueId(),
                name: '',
                relationship: '',
                dob: '',
                ssn: ''
            }
        ]);
    };

    const handleDependentRemove = (index) => {
        setDependents(prev => prev.filter((_, i) => i !== index));
    };

    const togglePasswordVisibility = (field) => {
        setShowPassword(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const resetForm = () => {
        setFormData(initialData);
        setDependents([]);
        setErrors({});
        setIsDirty(false);
    };

    const isValid = () => Object.keys(errors).length === 0;

    return {
        generateUniqueId,
        formData,
        setFormData,
        dependents,
        setDependents,
        errors,
        showPassword,
        loading,
        setLoading,
        handleInputChange,
        handleDependentChange,
        handleDependentAdd,
        handleDependentRemove,
        togglePasswordVisibility,
        resetForm,
        isValid,
        isDirty
    };
};
